// extracted by mini-css-extract-plugin
export default {"global-main-content-tips":"LandscapeTips_global-main-content-tips_a76xF","global-main-wrapper-tips":"LandscapeTips_global-main-wrapper-tips_bNaa0"};